var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdgeBrowser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "4kuvnxa2md",
    cx: 20.659,
    cy: 9.793,
    r: 3.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0)",
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0.5)",
    offset: "90%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i05inw2r1g",
    cx: 10.955,
    cy: 4.678,
    r: 3.585,
    gradientTransform: "rotate(-81.384 10.955 4.678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0)",
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 0, 0, 0.5)",
    offset: "90%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v78edzdfsi",
    cx: 3.236,
    cy: 5.914,
    r: 17.724,
    gradientTransform: "rotate(92.291 3.236 5.914)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4F1",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5E2",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6D4",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CA3D",
    offset: "70%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "jipkazmv0j",
    cx: 30.007,
    cy: 9.662,
    r: 12.162,
    gradientTransform: "rotate(73.74 30.007 9.662)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE5A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(0, 238, 90, 0)",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "whqthwwz6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v950H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "03tirao79b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.725 0a3.937 3.937 0 0 0-2.05 3.412c0 5.225 5.15 9.288 11.062 9.288a12.737 12.737 0 0 0 4.487-.8c.454-.169.896-.365 1.325-.588a.5.5 0 0 1 .663.7 16.037 16.037 0 0 1-8.325 6.6l-.162.05c-.9.287-2.388.575-3.375.575C8.512 19.237 0 18.312 0 9.062 0 5.8 1.375.225 6.725 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h5cvmkicge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.99 9.698a3.987 3.987 0 0 0-.777-2.086A4.05 4.05 0 0 0 16 5.987c-.887-.012-1.55.313-1.95.5a10.087 10.087 0 0 0-3.687 15 9.9 9.9 0 0 0 2.837 2.662h.013a9.437 9.437 0 0 0 7.85 1c-7.698 2.57-16.1-1.03-19.55-8.375a16.274 16.274 0 0 1-1.512-7C0 5.2 4.513 0 10 0 23.061 0 20 9.925 20 9.95z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zhrbh9gn0h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0c6.212 0 11.924 2.975 14.587 8.15.412.825 1.45 2.687 1.412 5.487a7.675 7.675 0 0 1-3.8 6.612 7.45 7.45 0 0 1-3.787 1.038c-.013 0-3.4.175-5.188-1.075-.387-.263-.6-.588-.6-.913 0-.387.313-.575.425-.7l-.012.013c.637-.825.975-1.813.975-2.487 0-.675-.138-2.363-.9-3.688a9.075 9.075 0 0 0-3.862-3.662c-2.313-1.213-4.813-1.25-5.25-1.25-5.4 0-9.938 3.687-10 8.25C.123 7.026 7.25-.001 16 0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b8kwpvb9kc",
    x1: 0,
    y1: 9.625,
    x2: 22.299,
    y2: 9.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005AA9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004B8F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "slc1x73igf",
    x1: 19.075,
    y1: 6.437,
    x2: 5.163,
    y2: 21.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0097E5",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082DD",
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007ADA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#whqthwwz6a)",
    transform: "translate(-433 -314)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03tirao79b)",
    transform: "translate(440.337 327.012)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b8kwpvb9kc)",
    d: "M0 0h22.284v19.237H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#03tirao79b)",
    transform: "translate(440.337 327.012)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#4kuvnxa2md)",
    opacity: "35%",
    d: "M0 0h22.284v19.237H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h5cvmkicge)",
    transform: "translate(433.012 320.524)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#slc1x73igf)",
    d: "M0 0h21.063v25.976H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h5cvmkicge)",
    transform: "translate(433.012 320.524)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i05inw2r1g)",
    opacity: "41%",
    d: "M0 0h21.063v25.976H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zhrbh9gn0h)",
    transform: "translate(433 314.512)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#v78edzdfsi)",
    d: "M0 0h32v21.295H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zhrbh9gn0h)",
    transform: "translate(433 314.512)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#jipkazmv0j)",
    d: "M0 0h32v21.295H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeBrowser);
export default __webpack_public_path__ + "static/media/edge-browser.a89f9e2dc1c82539c3dcf3c3fabb5346.svg";
export { ForwardRef as ReactComponent };